import { FEATURED_IN_COUNTRY } from 'helpers/graphql/locations';
import { useQuery } from '@apollo/client';
import DestinationItem from './DestinationItem';

// Featured regions as a static postcard grid — every region visible at a
// glance, no carousel arrows to wrestle with.
export default function SubdivisionGrid({ countryCode }) {
  const { data } = useQuery(FEATURED_IN_COUNTRY, {
    variables: { countryCode },
  });

  if (!data || !data.featuredInCountry || data.featuredInCountry.length === 0)
    return <></>;

  return (
    <div className="tw-grid tw-grid-cols-2 tw-gap-4 sm:tw-gap-6 lg:tw-grid-cols-4">
      {data.featuredInCountry.slice(0, 8).map(location => (
        <DestinationItem
          key={location.subdivision}
          destination={{ ...location, countryCode }}
          isPrio={false}
        />
      ))}
    </div>
  );
}
